import CardTweet from "../twitter/components/CardTweet";
import PostTweet from "../twitter/components/PostTweet";
import { useUser } from "../context/Usercontext";
import { useEffect } from "react";

let TweetsArea = function (navigate) {
  let {
    getPosts,
    setPosts,
    posts,
    fetchLikes,
    userObject,
    lastLikeDeleted,
    setLastLikeDeleted,
    likedPosts,
    loadingLikes,
    fetchedLikes,
    changer,
    loadingPosts,
  } = useUser();
  useEffect(() => {
    if (!changer) {
      getPosts();
      console.log("Loading posts");
    }
  }, [changer]);

  useEffect(() => {
    if (!fetchedLikes) {
      fetchLikes(userObject.id);
      console.log("Loading likes");
    }
  }, [fetchedLikes]);

  let buttonUnlikedSource =
    "https://img.icons8.com/android/22/null/fire-element.png";
  let buttonLikedSource =
    "https://img.icons8.com/color/28/null/fire-element--v1.png";

  return (
    <div className="tweets-area">
      <div className="tweets-area-logo-area">
        <img src="https://ik.imagekit.io/1u3yre5td/meh/meh-web-logo.png?ik-sdk-version=javascript-1.4.3&updatedAt=1678148933495" />
      </div>
      <PostTweet />
      {loadingPosts ? (
        <div className="tweets-area-loader-area">
          <span class="loader"></span>
        </div>
      ) : (
        posts.map((post) => (
          <CardTweet
            key={post.id}
            post={post}
            likedPosts={likedPosts}
            buttonLikedSource={buttonLikedSource}
            buttonUnlikedSource={buttonUnlikedSource}
            navigate={navigate}
          />
        ))
      )}
    </div>
  );
};

export default TweetsArea;
